import { getAuth } from "firebase/auth";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { removeCurrentAccount } from "@/shared/utils/sessionStorage.utils";

const AUTH_FLOW_ROUTE_NAMES = new Set([
  "login",
  "register",
  "invite",
  "resetpassword",
  "resetPassword",
]);

export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  if (to.matched.some((record) => record.meta.skipMerchantGuards)) {
    next();
    return;
  }

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (!requiresAuth || AUTH_FLOW_ROUTE_NAMES.has(String(to.name))) {
    next();
    return;
  }

  const { currentUser } = getAuth();
  if (!currentUser) {
    next();
    return;
  }

  if (!currentUser.emailVerified) {
    const pendingInviteToken = sessionStorage.getItem("pendingInviteToken");
    removeCurrentAccount();
    next({
      name: "register",
      query: { step: 2, ...(pendingInviteToken ? { token: pendingInviteToken } : {}) },
    });
    return;
  }

  const tokenResult = await currentUser.getIdTokenResult();
  if (!tokenResult.claims.account) {
    const pendingInviteToken = sessionStorage.getItem("pendingInviteToken");
    removeCurrentAccount();
    next({
      name: "register",
      query: { step: 3, ...(pendingInviteToken ? { token: pendingInviteToken } : {}) },
    });
    return;
  }

  next();
};
